/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseUserWeeklyScheduleExceptionDto } from '../../models/response-user-weekly-schedule-exception-dto';

export interface UserWeeklyScheduleExceptionsControllerFindOne$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * User email
 */
  email: string;

/**
 * Creation timestamp of the exception
 */
  createdAt: string;
}

export function userWeeklyScheduleExceptionsControllerFindOne(http: HttpClient, rootUrl: string, params: UserWeeklyScheduleExceptionsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>> {
  const rb = new RequestBuilder(rootUrl, userWeeklyScheduleExceptionsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('email', params.email, {});
    rb.path('createdAt', params.createdAt, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseUserWeeklyScheduleExceptionDto>;
    })
  );
}

userWeeklyScheduleExceptionsControllerFindOne.PATH = '/thalea-google-events/user-weekly-schedule-exceptions/{tenant}/{email}/{createdAt}';
